import React from "react";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import * as styles from "./styles.module.css";

type Props = {
    trialPeriod: number;
    productDisplayName: string;
    marketingShortDescription: string | null;
}

export function ProductName({ productDisplayName, trialPeriod, marketingShortDescription }: Props) {
    return (
        <div className={styles.container}>
            <h1 className={styles.name}>
                {productDisplayName ? (
                    <FormattedMessage
                        {...messages.nameWithProduct}
                        values={{ productDisplayName, trialPeriod, br: <br /> }}
                    />
                ) : (
                    <FormattedMessage
                        {...messages.name}
                        values={{ trialPeriod, br: <br /> }}
                    />
                )}
            </h1>
            {marketingShortDescription && (
                <div className={styles.description}>
                    {marketingShortDescription}
                </div>
            )}
        </div>
    );
}
